import {Component, inject} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { ThemeBarSettingsComponent } from "./theme-bar-settings/theme-bar-settings.component";
import { ColorpickerComponent } from "./colorpicker/colorpicker.component";

@Component({
  selector: 'app-theme-selector',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    ThemeBarSettingsComponent,
    ColorpickerComponent
],
  templateUrl: './theme-selector.component.html',
  styleUrl: './theme-selector.component.css'
})
export class ThemeSelectorComponent {
  private _formBuilder = inject(FormBuilder);

  isChecked = true;
  formGroup = this._formBuilder.group({
    enableTransparent: '',
  });
  triggerColorPicker(colorPicker: HTMLInputElement): void {
    colorPicker.click();
  }
  onColorChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const selectedColor = inputElement.value;
    console.log('Selected Color:', selectedColor);
    // Add additional logic to handle the selected color (e.g., update SVG fill)
  }

  // alertFormValues(formGroup: FormGroup) {
  //   console.log('Form Values:',JSON.stringify(formGroup.value, null, 2));
  // }
}
